export const profileUrl = "/api/user";
export const createProfile = () => ({
  username: "iturgeon",
  email: "iturgeon@gmail.com",
  points: "30",
  avatar:
    "https://www.gravatar.com/avatar/ea37c684d5f7c6dbb56dc208505c2664?s=100&r=r&d=mm",
  rating: 5,
  location: "Orlando",
  garage: "* A truck",
  google_authorship: "",
  amazon_affiliate: "",
  created_at: 0,
  bio: "I am me",
  forum: "forum",
});
